module.exports = __webpack_public_path__ + "static/media/cafe24-standoil1.d3c66faf.png";